import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberPapers } from "@api/members/papers/routeType";
import { useGetAllMemberPapers } from "@api/members/papers/getAll";
import { useGetMemberPaper } from "@api/members/papers/get";

const { getPath } = getApi("members.papers.delete");

type IExtractedRouteType = IMemberPapers["paperSingleDelete"];

export type IDeleteMemberPaper = IPickDelete<IExtractedRouteType>;

const deleteMemberPaper: MutationFunction<
  IDeleteMemberPaper["response"],
  IDeleteMemberPaper["variables"]
> = ({ memberId, paperId }) => {
  return axiosClient.delete(getPath({ memberId, paperId }));
};

export const useDeleteMemberPaper = createMutation({
  mutationFn: deleteMemberPaper,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberPapers.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberPaper.getKey({ memberId }),
    });
  },
});
